import React, { useState, useEffect, useContext, useRef } from 'react';
import ScrollAnimate from './ScrollAnimate';

const FooterLinkSection = ({ title, links }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`footer-links ${isOpen ? 'open' : ''}`}>
      <div className="footer-links-title" onClick={() => setIsOpen(!isOpen)}>{title}</div>
      <div className="footer-links-list">
        {links.map((link, index) => (
          <a key={index} className="footer-link" href={link.href}>{link.text}</a>
        ))}
      </div>
    </div>
  );
};

const Footer = () => {
  const footerSections = [
    {
      title: 'About',
      links: [
        { href: '#', text: 'Careers' },
        { href: '#', text: 'Contact' },
        { href: '#', text: 'Cookies' },
        { href: '#', text: 'Emails' },
        { href: '#', text: 'HackerNoon Tech' },
        { href: '#', text: 'Help' },
        { href: '#', text: 'Privacy' },
        { href: '#', text: 'Testimonials' },
        { href: '#', text: 'Shareholders' },
        { href: '#', text: 'Terms' }
      ]
    },
    {
      title: 'Read',
      links: [
        { href: 'http://hackernoon.com/archives', text: 'Archive' },
        { href: 'https://hackernoon.com/c', text: 'Categories' },
        { href: 'https://hackernoon.com/tagged/hackernoon-top-story', text: "Editors' Picks" },
        { href: 'https://terminal.hackernoon.com/', text: 'Terminal Reader' },
        { href: 'https://hackernoon.com/p/emails', text: 'Newsletters' },
        { href: 'http://hackernoon.com/signup', text: 'Signup' },
        { href: 'https://hackernoon.com/techbeat', text: 'Tech Beat' },
        { href: 'http://hackernoon.com/tagged', text: 'Tech Tags' },
        { href: 'https://hackernoon.com/writers', text: 'Top Bloggers' },
        { href: 'https://hackernoon.com/p/testimonials/readers-quotes', text: 'What Readers Say' }
      ]
    },
    {
      title: 'Write',
      links: [
        { href: 'https://help.hackernoon.com/distribution', text: 'Distribution' },
        { href: 'https://editingprotocol.com/', text: 'Editing Protocol' },
        { href: 'https://hackernoon.com/p/publish', text: 'Get Published' },
        { href: 'https://help.hackernoon.com/editorial-guideline', text: 'Guidelines' },
        { href: 'http://app.hackernoon.com/new', text: 'Start New Story' },
        { href: 'https://app.hackernoon.com/blogging-templates', text: 'Blogging Templates' },
        { href: 'https://hackernoon.com/p/publish', text: 'Process' },
        { href: 'https://hackernoon.com/how-to-gain-followers-and-newsletter-subs-directly-on-hackernoon', text: 'Subscribers' },
        { href: 'https://hackernoon.com/why-i-write-on-hacker-noon-nl28335q', text: 'Why Write' },
        { href: 'https://hackernoon.com/p/testimonials/contributing-writers-quotes', text: 'What Writers Say' }
      ]
    },
    {
      title: 'Business',
      links: [
        { href: 'https://calendly.com/hackernoon', text: 'Book Demo Meeting' },
        { href: 'https://business.hackernoon.com/business-blogging', text: 'Business Blogging' },
        { href: 'https://business.hackernoon.com/all-brands', text: 'All Brands' },
        { href: 'https://hackernoon.com/tagged/good-company', text: 'Live Business Posts' },
        { href: 'https://business.hackernoon.com/targeted-ads', text: 'Niche Targeting' },
        { href: 'https://business.hackernoon.com/writing-contests', text: 'Writing Contests' },
        { href: 'https://business.hackernoon.com/', text: 'Partnerships' },
        { href: 'https://hackernoon.com/startups', text: 'Top Startups' },
        { href: 'https://hackernoon.com/p/testimonials/customers-quotes', text: 'What Customers Say' },
        { href: 'https://hackernoon.com/u/hackmarketing', text: 'Hack Marketing Blog' }
      ]
    }
  ];

  const socialIcons = [
    { 
      name: 'X / Twitter', 
      href: 'https://twitter.com/hackernoon', 
      svg: `<svg id="x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m15.5,10v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-3v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1h-1v-1h-1v-2h-1v-1h-1v-1H1.5v1h1v1h1v1h1v2h1v1h1v2h1v1h1v2h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h3v-1h1v-1h1v-1h1v-1h1v-1h1v-1h2v1h1v1h1v2h1v1h1v1h7v-1h-1v-1h-1v-1h-1v-2h-1v-1h-1v-2h-1v-1h-1v-2h-1v-1h1Zm0,4v1h1v2h1v1h1v2h-3v-2h-1v-1h-1v-1h-1v-2h-1v-1h-1v-1h-1v-2h-1v-1h-1v-2h-1v-1h-1v-2h3v1h1v2h1v1h1v2h1v1h1v1h1v2h1Z" /></svg>` 
    },
    { 
      name: 'Facebook', 
      href: 'https://facebook.com/hackernoon', 
      svg: `<svg id="facebook-round" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="23 9 23 15 22 15 22 17 21 17 21 19 20 19 20 20 19 20 19 21 17 21 17 22 15 22 15 23 14 23 14 15 16 15 16 14 17 14 17 12 14 12 14 9 15 9 15 8 17 8 17 5 13 5 13 6 11 6 11 8 10 8 10 12 7 12 7 15 10 15 10 23 9 23 9 22 7 22 7 21 5 21 5 20 4 20 4 19 3 19 3 17 2 17 2 15 1 15 1 9 2 9 2 7 3 7 3 5 4 5 4 4 5 4 5 3 7 3 7 2 9 2 9 1 15 1 15 2 17 2 17 3 19 3 19 4 20 4 20 5 21 5 21 7 22 7 22 9 23 9" /></svg>` 
    },
    { 
      name: 'LinkedIn', 
      href: 'https://www.linkedin.com/company/hackernoon/', 
      svg: `<svg id="linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m22,2v-1H2v1h-1v20h1v1h20v-1h1V2h-1Zm-9,10v8h-3v-11h3v1h1v-1h4v1h1v10h-3v-8h-3Zm-9-4v-3h3v3h-3Zm3,1v11h-3v-11h3Z" /></svg>` 
    },
    { 
      name: 'Instagram', 
      href: 'https://instagram.com/hackernoon', 
      svg: `<svg id="instagram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m17,9v-1h-1v-1h-1v-1h-6v1h-1v1h-1v1h-1v6h1v1h1v1h1v1h6v-1h1v-1h1v-1h1v-6h-1Zm-1,5h-1v1h-1v1h-4v-1h-1v-1h-1v-4h1v-1h1v-1h4v1h1v1h1v4Z" /><path d="m22,5v-2h-1v-1h-2v-1H5v1h-2v1h-1v2h-1v14h1v2h1v1h2v1h14v-1h2v-1h1v-2h1V5h-1Zm-1,14h-1v1h-1v1H5v-1h-1v-1h-1V5h1v-1h1v-1h14v1h1v1h1v14Z" /><rect x="17" y="5" width="2" height="2" /></svg>` 
    },
    { 
      name: 'GitHub', 
      href: 'https://github.com/hackernoon', 
      svg: `<svg id="github" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="23 9 23 15 22 15 22 17 21 17 21 19 20 19 20 20 19 20 19 21 18 21 18 22 16 22 16 23 15 23 15 18 14 18 14 17 15 17 15 16 17 16 17 15 18 15 18 14 19 14 19 9 18 9 18 6 16 6 16 7 15 7 15 8 14 8 14 7 10 7 10 8 9 8 9 7 8 7 8 6 6 6 6 9 5 9 5 14 6 14 6 15 7 15 7 16 9 16 9 18 7 18 7 17 6 17 6 16 4 16 4 17 5 17 5 19 6 19 6 20 9 20 9 23 8 23 8 22 6 22 6 21 5 21 5 20 4 20 4 19 3 19 3 17 2 17 2 15 1 15 1 9 2 9 2 7 3 7 3 5 4 5 4 4 5 4 5 3 7 3 7 2 9 2 9 1 15 1 15 2 17 2 17 3 19 3 19 4 20 4 20 5 21 5 21 7 22 7 22 9 23 9" /></svg>` 
    },
    { 
      name: 'YouTube', 
      href: 'https://www.youtube.com/c/hackernoon', 
      svg: `<svg id="youtube" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m22,7v-2h-2v-1H4v1h-2v2h-1v10h1v2h2v1h16v-1h2v-2h1V7h-1Zm-10,8h-2v-6h2v1h2v1h2v2h-2v1h-2v1Z" /></svg>` 
    },
    { 
      name: 'Pinterest', 
      href: 'https://www.pinterest.com/hackernoon/', 
      svg: `<svg id="pinterest" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="23 9 23 15 22 15 22 17 21 17 21 19 20 19 20 20 19 20 19 21 17 21 17 22 15 22 15 23 9 23 9 21 10 21 10 18 11 18 11 17 12 17 12 18 16 18 16 17 17 17 17 16 18 16 18 14 19 14 19 10 18 10 18 8 17 8 17 7 16 7 16 6 14 6 14 5 10 5 10 6 8 6 8 7 7 7 7 8 6 8 6 10 5 10 5 14 6 14 6 15 7 15 7 16 8 16 8 14 7 14 7 10 8 10 8 8 10 8 10 7 14 7 14 8 16 8 16 9 17 9 17 14 16 14 16 15 15 15 15 16 11 16 11 14 12 14 12 9 10 9 10 10 9 10 9 17 8 17 8 20 7 20 7 21 5 21 5 20 4 20 4 19 3 19 3 17 2 17 2 15 1 15 1 9 2 9 2 7 3 7 3 5 4 5 4 4 5 4 5 3 7 3 7 2 9 2 9 1 15 1 15 2 17 2 17 3 19 3 19 4 20 4 20 5 21 5 21 7 22 7 22 9 23 9" /></svg>` 
    },
    { 
      name: 'Giphy', 
      href: 'https://giphy.com/hackernoon', 
      svg: `<svg id="giphy" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="20 9 21 9 21 23 3 23 3 1 12 1 12 2 11 2 11 3 5 3 5 21 19 21 19 10 20 10 20 9" /><polygon points="21 6 21 8 13 8 13 1 15 1 15 3 18 3 18 6 21 6" /></svg>` 
    },
    { 
      name: 'Figma', 
      href: 'https://www.figma.com/@hackernoon', 
      svg: `<svg id="figma" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m18,3.5v-1h-1v-1H7v1h-1v1h-1v3h1v1h1v2h-1v1h-1v3h1v1h1v2h-1v1h-1v3h1v1h1v1h5v-1h1v-6h4v-1h1v-1h1v-3h-1v-1h-1v-2h1v-1h1v-3h-1Zm-7,18h-3v-1h-1v-3h1v-1h3v5Zm0-7h-3v-1h-1v-3h1v-1h3v5Zm0-7h-3v-1h-1v-3h1v-1h3v5Zm6,3v3h-1v1h-2v-1h-1v-3h1v-1h2v1h1Zm-1-4v1h-3V2.5h3v1h1v3h-1Z" /></svg>` 
    },
    { 
      name: 'Reddit', 
      href: 'https://www.reddit.com/r/hackernoon/', 
      svg: `<svg id="reddit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="14" y="15" width="1" height="1" /><rect x="13" y="12" width="2" height="2" /><rect x="9" y="12" width="2" height="2" /><rect x="9" y="15" width="1" height="1" /><path d="m22,9v-2h-1v-2h-1v-1h-1v-1h-2v-1h-2v-1h-6v1h-2v1h-2v1h-1v1h-1v2h-1v2h-1v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1v-6h-1Zm-3,5h-1v1h-1v2h-1v1h-2v1h-4v-1h-2v-1h-1v-3h-1v-1h-1v-2h1v-1h2v1h1v-1h3v-5h2v1h3v2h-2v-1h-2v3h2v1h1v-1h2v1h1v3Z" /><rect x="10" y="16" width="4" height="1" /></svg>` 
    },
    { 
      name: 'Unsplash', 
      href: 'https://unsplash.com/@hackernoon', 
      svg: `<svg id="unsplash" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="8" y="1" width="8" height="6" /><polygon points="23 11 23 23 1 23 1 11 8 11 8 17 16 17 16 11 23 11" /></svg>` 
    },
    { 
      name: 'Wikipedia', 
      href: 'https://en.wikipedia.org/wiki/HackerNoon', 
      svg: `<svg id="wikipedia" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="23 5 23 6 22 6 22 7 21 7 21 9 20 9 20 11 19 11 19 13 18 13 18 15 17 15 17 18 16 18 16 19 15 19 15 18 14 18 14 15 13 15 13 13 12 13 12 15 11 15 11 17 10 17 10 18 9 18 9 19 8 19 8 18 7 18 7 15 6 15 6 13 5 13 5 11 4 11 4 9 3 9 3 7 2 7 2 6 1 6 1 5 6 5 6 6 5 6 5 7 6 7 6 9 7 9 7 11 8 11 8 13 9 13 9 15 10 15 10 14 11 14 11 12 12 12 12 11 11 11 11 9 10 9 10 7 9 7 9 6 8 6 8 5 12 5 12 6 11 6 11 7 12 7 12 8 14 8 14 6 13 6 13 5 17 5 17 6 16 6 16 7 15 7 15 9 14 9 14 12 15 12 15 14 17 14 17 12 18 12 18 10 19 10 19 8 20 8 20 6 19 6 19 5 23 5" /></svg>` 
    },
    { 
      name: 'Bluesky', 
      href: 'https://web-cdn.bsky.app/profile/hackernoon.com/post/3ldii5f6jrz27', 
      svg: `<svg id="bluesky" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23 3V11H22V13H20V14H18V15H20V16H21V19H20V20H19V21H17V22H15V21H14V20H13V18H11V20H10V21H9V22H7V21H5V20H4V19H3V16H4V15H6V14H4V13H2V11H1V3H2V2H4V3H6V4H7V5H8V6H9V7H10V9H11V10H13V9H14V7H15V6H16V5H17V4H18V3H20V2H22V3H23Z" /></svg>` 
    },
    { 
      name: 'Crunchbase', 
      href: 'https://www.crunchbase.com/organization/hackernoon', 
      svg: `<svg id="crunchbase" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m22,2v-1H2v1h-1v20h1v1h20v-1h1V2h-1ZM5,10h5v1h1v2h-2v-1h-3v3h3v-1h2v2h-1v1h-5v-1h-1v-5h1v-1Zm14,7h-4v-1h-1v1h-1V7h2v3h4v1h1v5h-1v1Z" /><rect x="15" y="12" width="3" height="3" /></svg>` 
    },
    { 
      name: 'Threads', 
      href: 'https://www.threads.net/@hackernoon/post/DHVmB-WILwY', 
      svg: `<svg id="threads" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 7V5H20V4H19V3H18V2H16V1H8V2H6V3H5V4H4V5H3V8H2V16H3V19H4V20H5V21H6V22H8V23H16V22H18V21H19V20H20V19H21V12H20V11H19V10H16V8H15V7H14V6H10V7H9V8H8V9H11V8H13V9H14V10H10V11H9V12H8V16H9V17H10V18H14V17H15V16H16V12H18V13H19V18H18V19H17V20H15V21H9V20H7V19H6V18H5V15H4V9H5V6H6V5H7V4H9V3H15V4H17V5H18V6H19V8H22V7H21ZM13 15V16H11V15H10V13H11V12H13V13H14V15H13Z" /></svg>` 
    },
    { 
      name: 'Kaggle', 
      href: 'https://www.kaggle.com/hackernoon', 
      svg: `<svg id="kaggle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 15V16H13V17H14V18H15V19H16V20H17V21H18V22H19V23H15V22H14V21H13V20H12V19H11V18H9V19H8V23H5V1H8V15H9V14H10V13H11V12H12V11H13V10H14V9H15V8H19V9H18V10H17V11H16V12H15V13H14V14H13V15H12Z" /></svg>` 
    },
    { 
      name: 'Podcast', 
      href: 'https://hackernoon.com/p/hackernoon-podcast', 
      svg: `<svg id="podcasts" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="9 14 8 14 8 12 11 12 11 11 8 11 8 9 11 9 11 8 8 8 8 6 11 6 11 5 8 5 8 3 9 3 9 2 10 2 10 1 14 1 14 2 15 2 15 3 16 3 16 5 13 5 13 6 16 6 16 8 13 8 13 9 16 9 16 11 13 11 13 12 16 12 16 14 15 14 15 15 14 15 14 16 10 16 10 15 9 15 9 14" /><polygon points="19 12 19 15 18 15 18 17 17 17 17 18 15 18 15 19 13 19 13 21 16 21 16 23 8 23 8 21 11 21 11 19 9 19 9 18 7 18 7 17 6 17 6 15 5 15 5 12 6 12 6 14 7 14 7 16 8 16 8 17 10 17 10 18 14 18 14 17 16 17 16 16 17 16 17 14 18 14 18 12 19 12" /></svg>` 
    },
    { 
      name: 'Product Hunt', 
      href: 'https://www.producthunt.com/products/hacker-noon', 
      svg: `<svg id="product-hunt" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="15 9 15 11 14 11 14 12 10 12 10 8 14 8 14 9 15 9" /><path d="m22,9v-2h-1v-2h-1v-1h-1v-1h-2v-1h-2v-1h-6v1h-2v1h-2v1h-1v1h-1v2h-1v2h-1v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1v-6h-1Zm-6,4h-2v1h-4v4h-2V6h6v1h2v1h1v4h-1v1Z" /></svg>` 
    },
    { 
      name: 'Viewblock', 
      href: 'https://viewblock.io/arweave/address/X8se6ANj4C-gpP_JH0ZbtJJEpyHBr0XQA-crCpbZGak', 
      svg: `<svg id="viewblock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m21,11v-2h-1v-2h-1v-1h-1v-1h-1v-1h-2v-1h-2V1h-2v2h-2v1h-2v1h-1v1h-1v1h-1v2h-1v2H1v2h2v2h1v2h1v1h1v1h1v1h2v1h2v2h2v-2h2v-1h2v-1h1v-1h1v-1h1v-2h1v-2h2v-2h-2Zm-10,8h-1v-1h-2v-1h-1v-1h-1v-1h-1v-6h1v1h1v1h1v1h2v1h1v6Zm-1-8v-1h-2v-1h-1v-1h-1v-1h2v-1h2v-1h4v1h2v1h2v1h-1v1h-1v1h-2v1h-4Zm9,4h-1v1h-1v1h-1v1h-2v1h-1v-6h1v-1h2v-1h1v-1h1v-1h1v6Z" /></svg>` 
    },
    { 
      name: 'Google News', 
      href: 'https://news.google.com/search?q=hackernoon&hl=en-US&gl=US&ceid=US%3Aen', 
      svg: `<svg id="google-news" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m20,10v-1H4v1h-1v11h1v1h16v-1h1v-11h-1Zm-7,3h5v1h-5v-1Zm-2,5h-1v1h-4v-1h-1v-4h1v-1h4v1h-3v1h-1v2h1v1h2v-1h1v-1h-2v-1h3v3Zm7,0h-5v-1h5v1Zm-5-2v-1h6v1h-6Z" /><polygon points="23 8 23 12 22 12 22 9 21 9 21 8 16 8 16 6 19 6 19 7 22 7 22 8 23 8" /><polygon points="15 3 10 3 10 4 7 4 7 5 5 5 5 3 6 3 6 2 18 2 18 3 19 3 19 5 15 5 15 3" /><polygon points="14 6 15 6 15 8 3 8 3 9 2 9 2 12 1 12 1 8 2 8 2 7 5 7 5 6 8 6 8 5 11 5 11 4 14 4 14 6" /></svg>` 
    }
  ];

  return (
    <ScrollAnimate>
      <div className="footer">
        {footerSections.map((section, index) => (
          <FooterLinkSection key={index} title={section.title} links={section.links} />
        ))}
        
        <div className="footer-social">
          <div className="footer-social-title">Connect With Us</div>
          <div className="footer-social-icons">
            {socialIcons.map((icon, index) => (
              <a 
                key={index} 
                href={icon.href} 
                target="_blank" 
                rel="noopener noreferrer" 
                title={icon.name} 
                className="footer-social-icon"
                dangerouslySetInnerHTML={{ __html: icon.svg }}
              />
            ))}
          </div>
        </div>

        <div className="footer-copyright">
        &copy; {new Date().getFullYear()} HackerNoon. All rights reserved.
        </div>
      </div>
    </ScrollAnimate>
  );
};

export default Footer;